module.exports = __webpack_public_path__ + "media/images/step3-e805859a9cf55cc6f551912095f93356.png";